import axios from 'axios'

const API_URL = 'https://testiventpay.hisiastudio.com/testiventpay/api/'

const getPays = async () => {
    const response = await axios.get(API_URL + `pays/`)
    if(response.status === 200){
        if(response.data.results && response.data.results.length > 0){
            let array = []
            response.data.results.forEach(element => {
                array.push({value: element.slug, label: element.nom})
            })
            return array
        }else{
            return []
        }
    }else{
        return {msg: response.data, status: response.status}
    }
}

const paysService = {
    getPays,
}

export default paysService